export const css = {
	root: '_3n2pBUcC',
	content: '_14ubv1EJ',
	loading: '_3PtFVPMz',
	promote: 'FsAh-EV5',
	disabledPromote: '_16bPn07N',
	domain: '_2xSY1445',
	title: '_3aT_inOR',
	subtitle: '_193MT9jY',
	actions: 'G7vq2H1p',
	indicator: 'kzazgzZ0',
	' _key': 'afcpe-theme/afcpe/card/tgf'
};

export default css;
